import { Pipe, inject, PipeTransform } from '@angular/core';
import { ENVIRONMENT } from '@environment';

@Pipe({ name: 'removeColorsHTML', standalone: true })
export class RemoveColorsHtmlPipe implements PipeTransform {
  private readonly removeColorsHTML = inject(ENVIRONMENT).components?.removeColorsHTML;
  transform(html: string, type: 'moviesite'): string {
    if (!html) return '';

    if (type === 'moviesite') {
      console.log(this.removeColorsHTML?.movieSiteEnabled);
      return this.removeColorsHTML?.movieSiteEnabled ? html.replace(/color\s*:\s*[^;"']+/gi, '') : html;
    }

    return html;
  }
}
